import { render, staticRenderFns } from "./PersonalizeScreen.vue?vue&type=template&id=2943ea33&scoped=true"
import script from "./PersonalizeScreen.vue?vue&type=script&lang=js"
export * from "./PersonalizeScreen.vue?vue&type=script&lang=js"
import style0 from "./PersonalizeScreen.vue?vue&type=style&index=0&id=2943ea33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943ea33",
  null
  
)

export default component.exports